export default __webpack_public_path__ + "static/media/KOD0071-min.326694f0.webp";